import { type SvgProps, SvgWrapper } from '../utils';

export function ChevronUpIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M11.5264 8.41796C11.821 8.17765 12.2557 8.19512 12.5303 8.46972L18.5303 14.4697C18.8232 14.7626 18.8232 15.2374 18.5303 15.5303C18.2374 15.8232 17.7626 15.8232 17.4697 15.5303L12 10.0605L6.53028 15.5303C6.23738 15.8232 5.76262 15.8232 5.46973 15.5303C5.17684 15.2374 5.17684 14.7626 5.46973 14.4697L11.4697 8.46972L11.5264 8.41796Z" />
    </SvgWrapper>
  );
}
